'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Supported two factor authentication modes. NONE is used
 * for when no 2FA is used.
 */
(function (TwoFactorAuthMode) {
    TwoFactorAuthMode["NONE"] = "NONE";
    TwoFactorAuthMode["SMS"] = "SMS";
    TwoFactorAuthMode["EMAIL"] = "EMAIL";
    TwoFactorAuthMode["KBA"] = "KBA";
})(exports.TwoFactorAuthMode || (exports.TwoFactorAuthMode = {}));
(function (SIGN_UP_STEPS) {
    SIGN_UP_STEPS["STEP_1"] = "1";
    SIGN_UP_STEPS["STEP_2"] = "2";
    SIGN_UP_STEPS["STEP_3"] = "3";
    SIGN_UP_STEPS["STEP_4"] = "4";
})(exports.SIGN_UP_STEPS || (exports.SIGN_UP_STEPS = {}));
var VALID_TFA_VALUES = [
    exports.TwoFactorAuthMode.EMAIL,
    exports.TwoFactorAuthMode.KBA,
    exports.TwoFactorAuthMode.SMS,
];
/**
 * Utility function. It converts two factor authentication string coming from
 * site settings (CMS) to an array of valid TwoFactorAuthMode.
 * A validation is performed to ensure no invalid two factor auth string gets to the application.
 * It also allows CMS value to be lowercase to add some tolerance for mistyping in the CMS.
 *
 * @param twoFactorAuthModes: The comma separated list of authentication modes coming from Site Settings in the CMS
 * @retuns an array of TwoFactorAuthMode
 */
function sanitizeTwoFactorAuthModes(twoFactorAuthModes) {
    var tfaModesArray = [];
    twoFactorAuthModes.split(',').forEach(function (value) {
        var twoFactorSanitizedValue = value.trim().toUpperCase();
        if (VALID_TFA_VALUES.includes(twoFactorSanitizedValue)) {
            tfaModesArray.push(twoFactorSanitizedValue);
        }
    });
    return tfaModesArray;
}

exports.VALID_TFA_VALUES = VALID_TFA_VALUES;
exports.sanitizeTwoFactorAuthModes = sanitizeTwoFactorAuthModes;
